export default function Field({ label, id, value, onChange, placeholder, type = 'text', error, hint, required }) {
  return (
    <div className="ck-field">
      {label && <label className="ck-label" htmlFor={id}>{label}{required && <span style={{ color: 'var(--brand)', marginLeft: 2 }}>*</span>}</label>}
      <input
        id={id} type={type}
        className={`ck-input${error ? ' error' : ''}`}
        value={value} onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {error && <p className="ck-input-error">{error}</p>}
      {hint && !error && <p className="ck-input-hint">{hint}</p>}
    </div>
  );
}
